import React from 'react';
import KoimaSignup from './components/SignUpForm';
import './App.css';

function App() {
  return (
    <div className="App">
      <KoimaSignup />
    </div>
  );
}

export default App;
